import styled from 'styled-components';
import { colors } from 'global/colors';

export const TopHeadingContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 15px;
`;

export const CompanyCardContainer = styled.div`
  background-color: white;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 15px;
  justify-content: space-evenly;
`;

export const SectionContainer = styled.div``;

export const SectionTitle = styled.h5`
  color: ${colors.darkBlue};
  padding-bottom: 10px;
`;

export const CreateCompanyTab = styled.div`
  padding: 20px 10px 20px 20px;
  background-color: white;
  justify-content: flex-start;
`;

export const Header = styled.h1`
  color: ${colors.darkBlue};
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 42px;
  min-width: 220px;
`;

export const OuterContainer = styled.div`
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e5e5e5;
  background: white;
`;

const SwitchableInput = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: ${colors.darkGray};
  padding: 0;
  border-radius: 0;
  border-bottom: 1px solid ${colors.lightGray2};
`;

export const TextInput = styled(SwitchableInput)`
  font-size: 16px;
  display: flex;
  align-items: center;
  line-height: 20px;
  padding: 5px;
  width: ${(props) => props.width || '95%'};
  margin: ${(props) => props.margin || '10px 0 20px 0'};
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: baseline;
  width: 100%;
  flex-wrap: wrap;
`;

export const DescriptionQuillContainer = styled.div`
  background-color: white;
  margin-bottom: 15px;
`;

export const Label = styled.label`
  margin-left: 8px;
  margin-bottom: 0px;
  color: #373a3c;
  font-size: 15px;
  display: flex;
  align-items: end;
`;
